export type ToDoSectionVariant = 'urgent' | 'compliance';

export interface IToDoItem {
    key: string,
    label: string,
    count: number,
    onClick?: () => void
}
